'use client'

import { ReactNode } from 'react'

import '@style-port/roov-ui-components-core/assets/index.css'

import CommonSvg from '@style-port/roov-ui-components-core/assets/svg/common.svg'
import { UIAssetProvider, UIAssetsTypes } from '@style-port/roov-ui-components-react'

export default function UIAssetRegistry({ children }: { children: ReactNode }) {
  return (
    <UIAssetProvider assetsURL={{ [UIAssetsTypes.CommonIcon]: CommonSvg }}>
      {children}
    </UIAssetProvider>
  )
}
